import { GKClientDataGrid, GKModal } from "components";
import DotStatusField from "components/DotStatusField";
import { useFetchQuery } from "hooks/useQueries";
import { SingleStockItemInterface } from "interfaces/EquityBasket";
import { useParams } from "react-router-dom";
import { moneyCommaSeparator } from "utils";
import { GKModalProps } from "utils/commonInterface";
import { extraColumnsField, matchDate } from "utils/helpers";

const RecommendationTimelineModal = ({
  open,
  setOpen,
  selectedRecommendation,
}: GKModalProps & {
  selectedRecommendation: any;
}) => {
  const { id } = useParams();

  const { data } = useFetchQuery<{ data: SingleStockItemInterface }>({
    key: ["GET_RECOMMENDATION_TIMELINE"],
    route: `/model_portfolio/${id}/stock_item/${selectedRecommendation}/?is_recommendation=true`,
  });

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Recommendation Timeline"
      maxHeight="600px"
      width={"60%"}
    >
      <GKClientDataGrid
        rows={data?.data?.stockUniverseItemHistory || []}
        name="recommendationTimeline"
        columns={[
          {
            ...extraColumnsField("date", "date", 120, 1),
            valueFormatter: (params) => matchDate(params.value),
          },
          {
            ...extraColumnsField("rec. type", "recommendationType", 100, 1),
            renderCell: (params) => {
              const { recommendationType } = params?.row;

              return (
                <DotStatusField
                  statusString={recommendationType || "Pending"}
                />
              );
            },
          },
          {
            ...extraColumnsField("cmp (₹)", "cmp", 80, 1),
            valueFormatter: (params) => moneyCommaSeparator(params.value),
            type: "number",
          },
          {
            ...extraColumnsField("target (₹)", "targetPrice", 100, 1),
            valueFormatter: (params) => moneyCommaSeparator(params.value),
            type: "number",
          },
          {
            ...extraColumnsField("stop loss (₹)", "stopLoss", 110, 1),
            valueFormatter: (params) => moneyCommaSeparator(params.value),
            type: "number",
          },
          {
            ...extraColumnsField("upside pending", "upsidePending", 130, 1),
            valueFormatter: (params) => moneyCommaSeparator(params.value),
            type: "number",
          },
        ]}
      />
    </GKModal>
  );
};

export default RecommendationTimelineModal;
